import Sidebar from 'components/sidebar';
import PageHeader from 'components/page-header';
import PrimaryButtom from 'components/common/buttons/primary-btn';
import { detailsPages } from 'helpers/constant';
import { useLocation, Outlet } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from 'hooks/useAppDispatchSelector';
import { memo, useContext } from 'react';
import { LanguageContext } from 'context/language-context';
import { useTranslation } from 'react-i18next';
import { setSideModal } from 'store/features/modelSlice';
import { sideModalEnum, usersRoles } from 'helpers/utils';

const PrivatePage = () => {
  const { t } = useTranslation();
  const { lang } = useContext(LanguageContext);

  const { selectedOrganization } = useAppSelector(state => state.auth);
  const dispatch = useAppDispatch();

  const loc = useLocation().pathname;
  const isDetailsPage = detailsPages.includes(loc.split('/')[loc.split('/').length - 1]);

  const isSuperAdmin = selectedOrganization?.role_name === usersRoles?.SUPER_ADMIN;
  const isDealerAdmin = selectedOrganization?.role_name === usersRoles?.DEALER_ADMIN;
  return (
    <div className="flex h-screen w-screen overflow-hidden" key={lang}>
      <Sidebar />
      <div className="flex flex-col items-start justify-start flex-1 h-full">
        <PageHeader />
        <div
          className="flex flex-col w-full h-full items-start justify-between bg-grey4"
          key={selectedOrganization?.organization_id}
        >
          {isDetailsPage ? (
            <div className="flex w-full h-full bg-grey4 px-[20px] py-[20px]">
              <Outlet />
            </div>
          ) : (
            <>
              <div
                className="flex flex-wrap lg:flex-nowrap justify-between h-auto lg:h-[200px] w-full min-h-auto
                 lg:min-h-[200px] max-h-auto lg:max-h-[200px] bg-[url('assets/common-cover-page.svg')] bg-no-repeat
                  bg-cover object-cover px-[20px] py-[20px] pb-[95px]"
              >
                <div className="w-auto">
                  <h1 className="text-xl lg:text-2xl text-white font-bold w-full block">
                    {t('DEALER_KER')}
                  </h1>
                  <label className="text-md lg:text-lg text-white font-medium w-full block">
                    {t('POSTER_SUBTITLE')}
                  </label>
                </div>
                {loc.includes('vehicles') && (isSuperAdmin || isDealerAdmin) ? (
                  <PrimaryButtom
                    label="DMS "
                    onClick={() =>
                      dispatch(
                        setSideModal({
                          type: sideModalEnum?.DMS_INTEGRATION,
                          content: { title: 'DMS Integration' },
                        }),
                      )
                    }
                  />
                ) : (
                  <></>
                )}
              </div>
              <div className="flex w-[calc(100%-40px)] bg-white py-[20px] px-[20px] mx-auto mb-[20px] -mt-20 relative content max-h-[calc(100%-150px)] overflow-hidden">
                <Outlet />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(PrivatePage);
